export default "__VITE_ASSET__CpXU0GfV__"